module.exports = __webpack_public_path__ + "img/woodwize-logo.4af09df5.png";